import React, { useState } from 'react';
import SliderV1 from '../slider/SliderV1';
import BoxNavigation from '../box_button/BoxButtonNavigation.js';
import HomeScrollGames from '../scroll/home_scroll_games.js';
import ProviderList from '../scroll/provider_scroll.js';
import PromotionSection from '../scroll/promotion_scroll.js';
import BestWinsSlider from '../slider/best_win_slider.js';
import JackPot from './casino/jackpot.js';
import { useTranslation } from 'react-i18next';


import LoadCategory from './casino/LoadCategory.js';
import SearchBox from './casino/searchbox.js';

import ModalLogin from '../modal/modal_login.js';

import NoResult from './casino/noresult.js';

import SearchResult from './casino/search_result.js';

import ProviderListCasino from './casino/provider_list.js';


import ModalGame from '../modal/modal_game.js';

import GameWeek from './casino/top_game.js';

import LOAD_GAMES_BY_SUBCATEGORY from '../modal/load_games_by_subcategory.js';

import Game from '../../../class/Game/Game';
import Games from '../../../class/Game_copy/Game';

const Casino = ({  isLogged,setIsLogged,AuthService,UserService,category, casinoSections, setIsLoginModalOpen }) => {

  const [showGamesModalSingleSubcategory, setshowGamesModalSingleSubcategory] = useState(false);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [selectedCategory, setSelectedcategory] = useState(null);
  const [selectedTagName, setSelectedTagName] = useState(null);

  const closeSubcategoryModal = () => {
    setSelectedcategory(null);
    setSelectedSubcategory(null);
    setshowGamesModalSingleSubcategory(false);
  };

  const openSingleSubcategoryModal = (category, subcategory, tagName) => {
    setSelectedcategory(category);
    setSelectedSubcategory(subcategory);
    setSelectedTagName(tagName);

    setshowGamesModalSingleSubcategory(true);
  };

  const { t } = useTranslation();


  return (
    <>
    {!casinoSections[category] ? (
      <>
    <div>
      {['casino'].includes(category) && isLogged && (

        <JackPot selection="casino" AuthService={AuthService} UserService={UserService} />
      )}
     
      {/* <SliderV1 lang={lang} sliderType="Casino" isLogged={isLogged} handleOpenRegisterModal={handleOpenRegisterModal} /> */}
      <SearchBox selection="casino" AuthService={AuthService} UserService={UserService} category={category}
      isLogged={isLogged}
      setIsLoginModalOpen={setIsLoginModalOpen}/>

     {/* <SearchResult selection="casino" AuthService={AuthService} UserService={UserService}/>  rgb(39, 50, 59)  */} 
      
      <div id="navigation" class="with-controls" style={{ background: 'rgb(1, 20, 60)', marginTop: '-4vw', marginBottom: '1vw', borderTop: '0px' }}>
        <section class="menu-bar bar">

          {(isLogged) && (
            <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
            onClick={() => openSingleSubcategoryModal(category, 'favorite_games', 'Favorite_games')}>
              <div class="navigation-item-badge"><img src="/assets/img/icon-btn/favorite_games-icon.svg" style={{ filter: "invert(0.8)"}} alt="Opzione 1"/></div>
              {t('Favorite_games')}
            </a>
          )}

          
          {(!casinoSections['casino'] && category === 'casino') && (
            <>
              {(isLogged) && (
              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino', 'recent_casino', 'Recent_games')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/recent_casino-icon.png" alt="Opzione 1"/></div>
                {t('Last_played')}
              </a>
              )}

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino', 'megaways_casino', 'Megaways')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/megaways_casino-icon.png" alt="Opzione 1"/></div>
                {t('Megaways')}
              </a>

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino', 'fruit_casino', 'Fruit')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/fruit_casino-icon.png" alt="Opzione 1"/></div>
                {t('Fruit')}
              </a>
              
              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino', 'tablegame_casino', 'Table_games')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/tablegame_casino-icon.png" alt="Opzione 1"/></div>
                {t('Table_games')}
              </a>

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino', 'multiline_casino', 'Multiline')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/multiline_casino-icon.png" alt="Opzione 1"/></div>
                {t('Multiline')}
              </a>

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino', 'videopoker_casino', 'Video_poker')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/videopoker_casino-icon.png" alt="Opzione 1"/></div>
                {t('Video_poker')}
              </a>

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino', 'other_casino', 'Other_games')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/other_casino-icon.png" alt="Opzione 1"/></div>
                {t('Other_games')}
              </a>

            </>
          )}


          {(!casinoSections['casino_live'] && category === 'casino-live') && (
            <>
              {(isLogged) && (
              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino-live', 'recent_live', 'Recent_games')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/recent_live-icon.png" alt="Opzione 1"/></div>
                {t('Last_played')}
              </a>
              )}

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino-live', 'roulette_live', 'Roulette')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/roulette_live-icon.png" alt="Opzione 1"/></div>
                {t('Roulette')}
              </a>
              
              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino-live', 'blackjack_live', 'Blackjack')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/blackjack_live-icon.png" alt="Opzione 1"/></div>
                {t('Blackjack')}
              </a>

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino-live', 'baccarat_live', 'Baccarat')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/baccarat_live-icon.png" alt="Opzione 1"/></div>
                {t('Baccarat')}
              </a>

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino-live', 'showgame_live', 'Show_games')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/showgame_live-icon.png" alt="Opzione 1"/></div>
                {t('Show_games')}
              </a>

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino-live', 'asiangame_live', 'Asian_games')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/asiangame_live-icon.png" alt="Opzione 1"/></div>
                {t('Asian_games')}
              </a>

              <a style={{ textTransform: 'none', background: '#ffffff' , textDecoration: 'none', height: '100%', boxShadow: 'rgb(42 63 87) 0 2px 4px, rgb(12 28 40 / 30%) 0 7px 13px -3px, #1a262d 0 -3px 0 inset' }} className={`menu-bar-item ${category === '' ? 'active' : ''}`}
              onClick={() => openSingleSubcategoryModal('casino-live', 'other_live', 'Other_games')}>
                <div class="navigation-item-badge"><img src="/assets/img/icon-btn/other_live-icon.png" alt="Opzione 1"/></div>
                {t('Other_games')}
              </a>

            </>
          )}
        </section>
      </div>
      
      
     {category === 'crash-game' ? (
          <LoadCategory category="crash-game" limit={30} page={1} AuthService={AuthService}
            isLogged={isLogged}
            setIsLoginModalOpen={setIsLoginModalOpen}
          />
        ) : (
          <ProviderListCasino
            game_slugs={['casino']}
            limit="4"
            AuthService={AuthService}І
            UserService={UserService}
            category={category}
            isLogged={isLogged}
            setIsLoginModalOpen={setIsLoginModalOpen}
          />
        )}
      

      {/*<GameWeek /> */} 

      <BestWinsSlider selection={category} />

      



    </div>

    {showGamesModalSingleSubcategory && selectedSubcategory && selectedCategory && selectedTagName && (
      <LOAD_GAMES_BY_SUBCATEGORY
        Game={Games}
        AuthService={AuthService}
        user_id={AuthService.getCustom('user_id') || ''}
        subcategory_slug={selectedSubcategory} 
        category_slug={selectedCategory}
        tag_name={selectedTagName}
        onClose={closeSubcategoryModal}
        isLogged={isLogged}
        setIsLoginModalOpen={setIsLoginModalOpen}
      />
    )}
    </>
    ) : 
      <NoResult />
    }
    </>
  );
};

export default Casino;
